
import ROUTE_SYSTEM_MANAGE from './system-manage'
import change_manage from './change-manage'
import DEMAND_MANAGE from './demand-manage'
import project_manage from './project-manage'
import COMMON from './common'
import report_manage from './report-manage'
import my_workbench from './my-workbench'
import meeting_manage from './meeting-manage'

export default [
    ...ROUTE_SYSTEM_MANAGE,
    ...change_manage,
    ...DEMAND_MANAGE,
    ...project_manage,
    ...COMMON,
    ...report_manage,
    ...my_workbench,
    ...meeting_manage
]



// WEBPACK FOOTER //
// ./src/router/mapping/index.js